<template>
  <transition name="slide">
    <div
      :class="[notificationState ? notificationState : '']"
      class="m-boxNotification m-boxNotification--page-level"
      role="alert">
      <span>
        <slot name="message"></slot>
      </span>
      <span
        v-if="!hideCloseButton"
        class="m-boxNotification__close"
        @click="close"
      >
        <i class="fa fas fa-times"/>
      </span>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    notificationState: {
      type: String,
      default: ''
    },
    hideCloseButton: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>




// WEBPACK FOOTER //
// BoxNotification.vue?4b7fe82a